import{gql as t}from"@apollo/client";const e=t`
  mutation setUserAnswer(
    $contentPageId: Int
    $contentSnippetFormId: Int!
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $text: String!
    $userFlowStepTrackId: Int
  ) {
    questionAnswer {
      setUserAnswer(
        contentSnippetFormId: $contentSnippetFormId
        answerMultilineText: {
          contentPageId: $contentPageId
          contentSnippetFormId: $contentSnippetFormId
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          text: $text
          userFlowStepTrackId: $userFlowStepTrackId
        }
      ) {
        id
        contentSnippetQuestionId
        __typename
      }
    }
  }
`;export{e as SET_USER_ANSWER_MULTI_LINE_TEXT_MUTATION};
//# sourceMappingURL=useSetUserAnswerMultiLineText.graphql.js.map
